/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

import getCurrentMediaQuery from '../helpers/_getCurrentMediaQuery';

/* ====================================================================
   BEHAVIOURS —> MOBILE MENU
   ==================================================================== */

const mobileMenu = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'mobileMenu',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    toggleMenu() {
      this.panel.classList.toggle('is-open');
      this.trigger.classList.toggle('is-open');
    },
    closeMenu() {
      this.listItems.forEach((el, index) => {
        el.classList.remove('is-open');
      });
      this.panel.classList.add('is-open');
      this.trigger.classList.remove('is-open');

      this.isOpen = false;
    },
    triggerMenu() {
      this.isOpen == false ? (this.isOpen = true) : (this.isOpen = false);

      // this.listItems.forEach((el, index) => {
      //   if (this.isOpen) {
      //     setTimeout(() => {
      //       el.classList.remove('is-hidden');
      //     }, index * 40);
      //   } else {
      //     setTimeout(() => {
      //       el.classList.add('is-hidden');
      //     }, index * 30);
      //   }
      // });

      this.toggleMenu();
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */

      /**
       * Expose the behaviour object for debugging
       */
      console.log(`${this.name}:`, this);

      this.trigger = document.querySelector('[data-mobileMenu-trigger]');
      this.panel = this.node;
      // this.listItems = this.node.querySelectorAll('.nav__links li');

      // this.listItems.forEach((el) => {
      //   el.classList.add('is-hidden');
      // });
    },
    enabled() {
      /**
       * The behaviour has been enabled; functions, variable overwrites
       * etc. can be called here
       * All functions, variables etc. are accessible through `this
       */

      // expose this
      const bhvr = this;

      this.isOpen = false;
      // console.log('enanled');
      this.trigger.addEventListener('click', this.triggerMenu);

      HSC.closeMenu = this.closeMenu;
    },
    disabled() {
      /**
       * The behaviour has been disabled; functions, variable overwrites etc.
       * can be called here
       *
       * All functions and variables should be referenced through `this`
       */
    },
    destroy() {
      /**
       * The behaviour has been destroyed; any event listeners, intervals etc.
       * should be removed here
       *
       * All variables set to `this` will be removed automatically
       */
    },
  },
);

export default mobileMenu;
